import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/WhyChooseUs.css';
import { FaUniversity, FaChartLine, FaShieldAlt, FaPercentage, FaArrowRight } from 'react-icons/fa';

const WhyChooseUs = () => {
  const benefits = [
    {
      icon: <FaUniversity />,
      title: "Dedicated Banking",
      description:
        "Each Cause receives their own dedicated bank account with direct donor deposits. Fully FDIC insured with zero fund commingling, providing complete financial autonomy and transparency.",
    },
    {
      icon: <FaChartLine />,
      title: "Cutting-Edge Technology",
      description:
        "Access feature-rich high-visibility Cause dashboards, customizable donation pages, and comprehensive donor insights. Our innovative platform streamlines donor data, grants management and Cause operations.",
    },
    {
      icon: <FaShieldAlt />,
      title: "Complete Compliance Coverage",
      description:
        "We handle everything: tax receipting, payment processing, financial reporting, grant management, annual audits, and 990 filings. Focus on your mission while we manage the complexities.",
    },
    {
      icon: <FaPercentage />,
      title: "Transparent Value",
      description:
        "Just 5% covers your complete fiscal sponsorship needs - from banking to compliance to technology. The lowest rate in the industry, with donors having the option to cover this administrative cost.",
    },
  ];

  return (
    <section className="why-choose-us">
      <div className="container">
        <h2>Why Choose Cause & Impact?</h2>
        <p>
          Experience the next generation of fiscal sponsorship, where cutting-edge technology
          meets unparalleled service and transparency.
        </p>
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div className="benefit" key={index}>
              <div className="icon">{benefit.icon}</div>
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
        <Link to="/services" className="learn-more-link">
          <span>Explore Our Services</span>
          <FaArrowRight className="arrow-icon" />
        </Link>
      </div>
    </section>
  );
};

export default WhyChooseUs;
